import { BaseService, GET, Query, QueryMap, Signal } from 'ts-retrofit3';

import type { IResponse } from '@/Module/Core/Model/ApiModel';
import { HttpService } from '@/Module/Core/Service';
import { WORKSPACE_API } from '@/Module/Workspace/Constants';
import type { IBookmarkRequest, ILikeRequest, IMonthQuery, IVideosRequest } from '@/Module/Workspace/Model/ApiModel';
import type { IStatisticsDataReq } from '@/Module/Workspace/Model/ApiModel/IStatisticsDataReq';
import type {
  IBookmark,
  ILike,
  IRecentlyViewedVideo,
  IStatistics,
  IUserLastViewed,
  IVideoViewed,
  IViewedVideosInTimespan,
} from '@/Module/Workspace/Model/DataModel';

class WorkspaceService extends BaseService {
  @GET(WORKSPACE_API.GENERAL_STATISTICS)
  async getStatistics(
    @Query('recentDate') _recentDate: IStatisticsDataReq['RecentDate'],
    @Signal _signal: AbortSignal,
  ): Promise<IResponse<IStatistics[]>> {
    return <IResponse>{};
  }

  @GET(WORKSPACE_API.WEEKLY_VIEWED)
  async getSeenInWeek(@Signal _signal: AbortSignal): Promise<IResponse<IViewedVideosInTimespan[]>> {
    return <IResponse>{};
  }

  @GET(WORKSPACE_API.USER_LAST_VIEWED)
  async getUsersLastViewed(): Promise<IResponse<IUserLastViewed>> {
    return <IResponse>{};
  }

  @GET(WORKSPACE_API.MONTHLY_VIEWED)
  async getSeenInMonth(
    @Query('month') _query: IMonthQuery['month'],
    @Signal _signal: AbortSignal,
  ): Promise<IResponse<IViewedVideosInTimespan[]>> {
    return <IResponse>{};
  }

  @GET(WORKSPACE_API.LIKE)
  async getLike(@QueryMap _query: ILikeRequest, @Signal _signal: AbortSignal): Promise<IResponse<ILike[]>> {
    return <IResponse>{};
  }

  @GET(WORKSPACE_API.BOOKMARK)
  async getBookMark(@QueryMap _query: IBookmarkRequest, @Signal _signal: AbortSignal): Promise<IResponse<IBookmark[]>> {
    return <IResponse>{};
  }

  @GET(WORKSPACE_API.MOSTLY_VIEWED)
  async getMostlyViewed(@QueryMap _query: IVideosRequest, @Signal _signal: AbortSignal): Promise<IResponse<IVideoViewed[]>> {
    return <IResponse>{};
  }

  @GET(WORKSPACE_API.VIDEOS_FULL_DATA)
  async getViewedVideosFullData(
    @QueryMap _query: IVideosRequest,
    @Signal _signal: AbortSignal,
  ): Promise<IResponse<IRecentlyViewedVideo[]>> {
    return <IResponse>{};
  }
}

export default HttpService.build(WorkspaceService);
